/**
 * GraphQL type definitions matching backend schema — team pillar.
 * Split from graphql/types.ts (issue #1409).
 */

import type { PageInfo } from './common';
import type { Service } from './service';

/**
 * Team type enumeration
 */
export enum TeamType {
  Development = 'development',
  Operations = 'operations',
  Platform = 'platform',
  Security = 'security',
  Data = 'data',
}

/**
 * Team entity
 */
export interface Team {
  entityId: string;
  entityType: string;
  name: string;
  description?: string | null;
  type: TeamType;
  parentTeamId?: string | null;
  parentTeam?: Team | null;
  childTeams?: Team[];
  leadUserId: string;
  memberIds: string[];
  responsibilities: string[];
  contactEmail: string;
  teamsChannel?: string | null;
  services?: Service[];
  _schemaVersion: string;
  _createdAt: string;
  _createdBy: string;
  _updatedAt: string;
  _updatedBy: string;
  _deletedAt?: string | null;
}

/**
 * Team edge for pagination
 */
export interface TeamEdge {
  node: Team;
  cursor: string;
}

/**
 * Team connection for paginated results
 */
export interface TeamConnection {
  edges: TeamEdge[];
  pageInfo: PageInfo;
  totalCount?: number | null;
}

/**
 * Input for filtering teams
 */
export interface TeamFilter {
  type?: TeamType;
  parentTeamId?: string;
  includeDeleted?: boolean;
}

/**
 * Team hierarchy node (recursive structure)
 */
export interface TeamHierarchyNode {
  team: Team;
  children: TeamHierarchyNode[];
  depth: number;
}
